<template>
  <div>
    <el-dropdown
      :title="$i18n.t('queue_actions')"
      @command="setAction"
      :disabled="disabled"
      placement="bottom-start"
      trigger="click"
    >
      <span class="el-dropdown-link">
        <span class="material-icons md-18">schedule_send</span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="action in queueActionsButtons" :key="action.processId" :command="action">
          {{ $i18n.t(action.name) }}
        </el-dropdown-item>
      </el-dropdown-menu>
      <el-drawer size="20%" :visible.sync="isConfirmOpen" :title="getTitle" direction="ttb" append-to-body>
        <div class="new-modal-content">
          <div class="new-modal-footer">
            <button type="button" class="el-button el-button--primary mt-4 ms-4" @click="onConfirm">
              <i></i>
              {{ $i18n.t('modal_confirm') }}
            </button>
          </div>
        </div>
      </el-drawer>
    </el-dropdown>
  </div>
</template>

<script>
import { cloneDeep, get, isEmpty, map } from 'lodash'
import EventBus from '../../../utils/event-bus'
import notifyMixin from '../../../utils/mixin-notify'
import hamburgerMixin from './mixin-hamburger'

export default {
  name: 'QueueAction',
  mixins: [notifyMixin, hamburgerMixin],
  data() {
    return {
      isConfirmOpen: false,
    }
  },
  computed: {
    aggr() {
      return this.aggregations
        ? JSON.stringify(
            this.aggregations.reduce((accumulator, { column = '', aggr = 'Off' }) => {
              if (aggr !== 'Off') {
                accumulator.push({ column, aggr })
              }
              return accumulator
            }, []),
          )
        : []
    },
    disabled() {
      return this.runGroupActionsOnAllWithoutSelect ? !this.runGroupActionsOnAllWithoutSelect : this.selectedRows <= 0
    },
    getTitle() {
      const rows =
        this.runGroupActionsOnAllWithoutSelect && isEmpty(this.selectedRows)
          ? this.total
          : this.selectedRows.length
      return this.$i18n.interpolate(this.$i18n.t('are_you_sure_to_run_group_actions_on_rows: ${rows}'), { rows })
    },
    hiddenSearch() {
      return this.$get('hiddenSearch')
    },
    mongoList() {
      return this.$get('mongoList')
    },
    primaryKey() {
      return this.$get('primaryKey')
    },
    queueActionsButtons() {
      const processActions = this.$get('processActionsButtons') || []
      return processActions.filter((action) => action.isQueue)
    },
    runGroupActionsOnAllWithoutSelect() {
      return get(this.$get('extendedOptions'), 'runGroupActionsOnAllWithoutSelect', false)
    },
    selectedQueueAction() {
      return this.$get('selectedQueueAction')
    },
    searchParams() {
      return this.$get('searchParams')
    },
    u() {
      return this.$get('universalFilter')
    },
  },
  methods: {
    getFilteredModelIds() {
      const search = cloneDeep(this.searchParams)
      delete search.start

      return this.$client.execute({
        operationId: 'List_getList',
        method: 'post',
        parameters: {
          aggr: this.aggr,
          columns: this.availableInDetailView,
          controllerName: this.controllerName,
          formId: this.collectionOrId,
          hiddenSearchData: this.hiddenSearch,
          panelId: this.panelId,
          selectedRows: this.selectedRows,
          selectedRowsFilter: this.selectedRowsFilter,
          search,
          u: this.u.value || '',
          idOnly: true,
          showDetails: false,
          start: 0,
        },
        requestContentType: 'application/x-www-form-urlencoded',
      })
    },
    noti(status) {
      let noty
      if (status !== 200) {
        noty = {
          text: 'queueAction_status_failure',
          type: 'error',
          duration: 10,
        }
      } else {
        noty = {
          text: 'queueAction_status_success',
          type: 'success',
        }
      }
      this.showNotification(noty)
    },
    onConfirm() {
      this.isConfirmOpen = false
      this.runGroupAction()
    },
    async runGroupAction() {
      let operation = {
        operationId: 'ProcessBuilder_runProcesses',
        parameters: {
          listId: this.collectionOrId,
          id: this.selectedQueueAction,
        },
        method: 'post',
      }
      if (this.runGroupActionsOnAllWithoutSelect && isEmpty(this.selectedRows)) {
        const list = await this.getFilteredModelIds()
        operation.parameters.modelIDS = map(get(list, 'obj.data', []), this.primaryKey)
      } else {
        operation.parameters.modelIDS = this.selectedRows
      }

      this.$client.execute(operation).then((status) => {
        this.noti(status.status)
        EventBus.$emit('refresh-layout')

        const responseRedirect = get(status.body.__response, 'redirect', null)
        if (responseRedirect) {
          return (window.location.href = responseRedirect)
        }
      })
    },
    setAction(action) {
      this.isConfirmOpen = true
      this.$dispatch('setSelectedQueueAction', {
        processId: action.processId,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.grouped-hamburger {
  .el-dropdown-link {
    display: block;
    padding: 9px 15px;
  }
}
.icon-align {
  vertical-align: sub;
}
</style>
